import { Injectable } from '@angular/core';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { Http, Response } from '@angular/http';
import { constant } from '../../app.constants';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ICounty, ICountyZipCodes } from 'app/core/interfaces/counties.interface';
import { Provider } from '../providers/providers.model';

@Injectable()
export class ProvidersService extends ParentService {
  providerId$ = new BehaviorSubject<number>(null);
  save$ = new BehaviorSubject<boolean>(false);
  infoCounty$ = new BehaviorSubject<ICounty>(null);

  private provider = new BehaviorSubject<{ providerId: number, isProviderModal: boolean }>({
    providerId: 0,
    isProviderModal: false
  });
  private closedModalProviderSeeting = new BehaviorSubject<boolean>(false);
  private closedModalOauthClient = new BehaviorSubject<boolean>(false);

  public provider$ = this.provider.asObservable();
  public closedModalProviderSeeting$ = this.closedModalProviderSeeting.asObservable();
  public closedModalOauthClient$ = this.closedModalOauthClient.asObservable();

  private filterId = new BehaviorSubject<number>(null);
  public  filterId$ = this.filterId.asObservable();

  private providerEditing = new BehaviorSubject<Provider>(null);
  public providerEditing$ = this.providerEditing.asObservable();

  constructor(private _http: Http) {
    super();
  }

    getCompaniesByRider(riderId: number) {
      return this._http.get(`${constant.URL_ENABLE_COMPANIES}&RiderId=${riderId}`, this.getHeader())
              .map(res => res.json())
              .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @Description:
     * @param {string} method
     * @returns {Observable<any>}
     */
    getCompanies(method: string) {
        if (method === 'all') {
            return this._http.get(constant.URL_ENABLE_COMPANIES, this.getHeader())
                .map(res => res.json())
                .catch((error: any) => Observable.throw(error.json()));

        }else {
            return this._http.get(constant.URL_DISABLE_COMPANIES, this.getHeader())
                .map(res => res.json())
                .catch((error: any ) => Observable.throw(error.json()));
        }
    }

    /**
     * @Description:
     * @returns {Observable<any>}
     */
    getAllBrokers() {
        return this._http.get(constant.URL_ENABLE_PROVIDER, this.getHeader())
            .map(res => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @Description:
     * @param date
     * @returns {Observable<any>}
     */
    getProvidersWithTripCount(date) {
        return this._http.get(constant.URL_GET_COMPANY_TRIP_COUNT + date, this.getHeader())
            .map(res => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @Description:
     * @returns {Observable<any>}
     */
    getCompaniesNotOnDemand() {
        return this._http.get(constant.URL_COMPANY + 'ListNonOnDemand', this.getHeader())
            .map(res => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @Description:
     * @returns {Observable<any>}
     */
    getCompaniesOnDemand() {
        return this._http.get(constant.URL_COMPANY + 'ListByCategory/true', this.getHeader())
            .map(res => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @Description:
     * @returns {Observable<any>}
     */
    getOnDemandCompanies() {
        return this._http.get(constant.URL_COMPANIES + '/ListOnDemand', this.getHeader())
            .map(res => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @Description:
     * @param {number} companyId
     * @returns {Observable<any>}
     * @deprecated
     */
    getCompany(companyId: number) {
        return this._http.get(constant.URL_COMPANY + companyId, this.getHeader())
            .map(res => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    getCompanyById(companyId: number) {
        return this._http
          .get(`${constant.URL_COMPANY_BY_ID}/${companyId}`, this.getHeader())
          .map((res) => res.json())
          .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @Description:
     * @param data
     * @returns {Observable<any>}
     */
    postData(data: any) {
        const bodyString = JSON.stringify(data);
        return this._http.post(constant.URL_COMPANIES, bodyString, this.headerPost())
            .map((res: Response) => res.json(), (error: Response) => error.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @Description:
     * @param data
     * @returns {Observable<any>}
     */
    putData(data: any) {
        const bodyString = JSON.stringify(data);
        return this._http.put(constant.URL_COMPANIES, bodyString, this.headerPost())
            .map(
              (res: Response) => res.json(),
              (error: Response) => error.json()
            ).catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @description:
     * @param data
     * @returns {Observable<any>}
     */
    deleteData(data: any) {
        return this._http.delete(`${constant.URL_COMPANIES}/${data}`, this.headerPost())
            .map((res: Response ) => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @description:
     * @param data
     * @returns {Observable<any>}
     */
    postCountTripsByStatus(data: any) {
        const bodyString = JSON.stringify(data);
        return this._http.post(constant.COUNTTRIPSBYSTATUS, bodyString, this.headerPost())
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @description:
     * @param data
     * @returns {Observable<any>}
     */
    postCountTripsByCompany (data: any) {
        const bodyString = JSON.stringify(data);
        return this._http.post(constant.COUNTTRIPSBYCOMPANY, bodyString, this.headerPost())
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @description:
     * @returns {Observable<any>}
     */
    getBanks() {
        return this._http.get(constant.URL_GET_BANKS, this.getHeader()).map( res => res.json());
    }

    /**
     * @description
     * @param showDisableData
     * @param payorIdData
     * @returns {Observable<any>}
     */
    getProviderFeeSchedule(showDisableData, payorIdData) {
        return this._http.get(constant.URL_PROVIDER_FEE_SCHEDULE +
            '?showDisable=' + showDisableData + '&providerid=' + payorIdData, this.getHeader())
            .map( res => res.json());
    }

    /**
     * @description
     * @param data
     * @returns {Observable<any>}
     */
    deleteDataFeeSchedule(data: any) {
        return this._http.delete(`${constant.URL_PROVIDER_FEE_SCHEDULE}/${data}`, this.headerPost())
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @description
     * @param {number} feeScheduleId
     * @returns {Observable<any>}
     */
    getFeeScheduleById(feeScheduleId: number) {
        return this._http.get(constant.URL_PROVIDER_FEE_SCHEDULE + '/' + feeScheduleId, this.getHeader()).map( res => res.json());
    }

    /**
     * @description
     * @param data
     * @returns {Observable<any>}
     */
    deleteRate(data: any) {
        return this._http.delete(`${constant.URL_PROVIDER_RATE}/${data}`, this.headerPost())
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @description
     * DOCUMENTS
     */
    getDocuments(providerid: number) {
        return this._http.get(constant.URL_PROVIDER_DOCUMENT + '/list/' + providerid, this.getHeader()).map(res => res.json());
    }

    /**
     * @description
     * @param data
     * @returns {Observable<any>}
     */
    addDocument(data) {
        const bodyString = JSON.stringify(data);
        return this._http.post(constant.URL_PROVIDER_DOCUMENT, bodyString, this.headerPost())
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @description
     * @param {number} driverid
     * @param {boolean} active
     * @returns {Observable<any>}
     */
    getLicenses(driverid: number, active: boolean) {
        return this._http.get(constant.URL_GET_LICENSES + '/' + driverid + '/' + active, this.getHeader()).map(res => res.json());
    }

    /**
     * @description
     * @param data
     * @returns {Observable<any>}
     */
    addLicense(data) {
        const bodyString = JSON.stringify(data);
        return this._http.post(constant.URL_ADD_LICENSE, bodyString, this.headerPost())
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @description
     * @returns {Observable<any>}
     */
    getLicenseTypes() {
        return this._http.get(constant.URL_GET_LICENSE_TYPES, this.getHeader()).map(res => res.json());
    }

    /**
     * @description
     * @param {number} providerId
     * @returns {Observable<any>}
     */
    getProviderCountry(providerId: number) {
        return this._http.get(constant.PROVIDERCOUNTRY + providerId, this.getHeader()).map(res => res.json());
    }

    /**
     * @description
     * @param data
     * @returns {Observable<any>}
     */
    postProviderCountry(data: any) {
        const bodyString = JSON.stringify(data);
        return this._http.post(constant.PROVIDERCOUNTRY_POST, bodyString, this.headerPost())
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    getProviderCountyZipCode(providerId: number, countyId: number) {
      return this._http.get(constant.URL_PROVIDER_COUNTY_GET + providerId + '/' + countyId, this.getHeader()).map(res => res.json());
    }

    putProviderCountyZipCode(data: any) {
      const bodyString = JSON.stringify(data);
      return this._http.put(constant.URL_PROVIDER_COUNTY_PUT, bodyString, this.headerPost())
        .map((res: Response) => res.json())
        .catch((error: any) => Observable.throw(error.json()));
    }

    getCompaniesAll(disabled: boolean) {
      return this._http.get(`${constant.URL_COMPANIES}?showDisabled=${disabled}&orderBy=true` , this.getHeader())
        .map(res => res.json())
        .catch((error: any) => Observable.throw(error.json()));
    }

  /**
   * @description para crear un FeeSchedule
   * @param data
   * @returns {Observable<any>}
   */
  public postDataFeeSchedule(data: any): Observable<any> {
    delete data.charge;
    const bodyString = JSON.stringify(data);
    return this._http.post(`${constant.URL_PROVIDER_FEE_SCHEDULE}`, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  deleteCounty(providerCountyId: number) {
    return this._http
      .delete(
        `${constant.PROVIDERCOUNTRY_POST}/${providerCountyId}`,
        this.headerPost()
      )
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getCounties(providerId: number) {
    return this._http
      .get(`${constant.GET_PROVIDER_COUNTRY}/${providerId}`, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getCountiesAvailable(providerId: number) {
    return this._http
      .get(`${constant.GET_PROVIDER_AVAILABLE_COUNTIES}/${providerId}`, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getZipCodes(providerCountyId: number, countyId: number) {
    return this._http
      .get(`${constant.GET_PROVIDER_ZIP_CODES}/${providerCountyId}/${countyId}`, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  saveCounties(data: any) {
    return this._http
      .post(constant.PROVIDERCOUNTRY_POST, data, this.headerPost())
      .map(
        (res: Response) => res.json(),
        (error: Response) => error.json()
      )
      .catch((error: any) => Observable.throw(error.json()));
  }

  saveZipCodes(zipCodes: ICountyZipCodes[]) {
    return this._http
      .post(constant.PROVIDERCOUNTRY_ZIP_CODES_POST, zipCodes, this.headerPost())
      .map(
        (res: Response) => res.json(),
        (error: Response) => error.json()
      )
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
 * @description
 * @param {number} providerId
 * @returns {Observable<any>}
 */
  getUserProvider(providerId: number) {
    return this._http
      .get(
        `${constant.URL_USER_PROFILE_GET_USER}?providerId=${providerId}`,
        this.getHeader())
      .map((res) => res.json())
      .catch(error => Observable.throw(error.json()));
  }

  PostLinkedProvider(arraLinkedProvider: any[]) {
    return this._http
      .post(
        `${constant.URL_LINKEDPROVIDER}`,
        arraLinkedProvider,
        this.headerPost())
      .map((res: Response) => res.json())
      .catch(error => Observable.throw(error.json()));
  }

  setProviderId(data: { providerId: number, isProviderModal: boolean }): void {
    this.provider.next(data);
  }

  setClosedModalProviderSetting(closed: boolean): void {
    this.closedModalProviderSeeting.next(closed);
  }

  setClosedModalOauthClient(closed: boolean): void {
    this.closedModalOauthClient.next(closed);
  }

  getApiId(): Observable<any> {
    return this._http
      .get(constant.URL_COMPANY_GETAPIID, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  postProviderSetting(request: any[]): Observable<any> {
    return this._http
      .post(constant.URL_COMPANY_POST_PROVIDER_SETTING, request, this.headerPost())
      .map(
        (res: Response) => res.json(),
        (error: Response) => error.json()
      )
      .catch((error: any) => Observable.throw(error.json()));
  }

  putProviderSetting(request: any[]): Observable<any> {
    return this._http
      .put(constant.URL_COMPANY_PUT_PROVIDER_SETTING, request, this.headerPost())
      .map(
        (res: Response) => res.json(),
        (error: Response) => error.json()
      )
      .catch((error: any) => Observable.throw(error.json()));
  }

  getProviderSetting(providerId: number): Observable<any> {
    return this._http
      .get(`${constant.URL_COMPANY_PROVIDER_SETTING_GET}/${providerId}`, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  generateClientSecret(): Observable<any> {
    return this._http
      .get(constant.URL_COMPANY_PROVIDER_GENERATE_CLIENT_SECRET, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  postOauthClient(request: any[]): Observable<any> {
    return this._http
      .post(constant.URL_COMPANY_PROVIDER_POST_OAUTH_CLIENT, request, this.headerPost())
      .map(
        (res: Response) => res.json(),
        (error: Response) => error.json()
      )
      .catch((error: any) => Observable.throw(error.json()));
  }

  putOauthClient(request: any[]): Observable<any> {
    return this._http
      .put(constant.URL_COMPANY_PROVIDER_PUT_OAUTH_CLIENT, request, this.headerPost())
      .map(
        (res: Response) => res.json(),
        (error: Response) => error.json()
      )
      .catch((error: any) => Observable.throw(error.json()));
  }

  getOauthClient(providerId: number): Observable<any> {
    return this._http
      .get(`${constant.URL_COMPANY_PROVIDER_GET_OAUTH_CLIENT}/${providerId}`, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  setFilterId(filterId: number): void {
    this.filterId.next(filterId);
  }

  setProviderEditing(provider: Provider): void {
    this.providerEditing.next(provider);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/providers/providers.service.ts